var 
    $window,
    $body,
    MainMenu
;

(function($){

    MainMenu = {

        selectors : '#masthead,.main-menu,.menu-suspenso,.keyword-filters',
        $items : null,
        $menus : null,
        $keywords: null,

        init : function(){

            $body = $('body');
            $window = $(window);

            $items = $( this.selectors );
            if( $items.length ){

                this.$keywords = $( 'input[name="s"]' );

                $items.each(function(){
                    MainMenu.configure( this );
                });

            }

        },

        configure : function( menu ){

            menu.$ = menu.$ || $( menu );
            
            var data = menu.$.data( 'MainMenu' );
            if( data !== undefined ) return data;

            data = {
                _ : menu,
                $ : menu.$,
                $overlay : $( '.menu-overlay', menu.$ ),
                $menuToggle : $( '.menu-toggle', menu.$ ),
                $search : $( '.search-box', menu.$ ),
                closeBlur : false
            };

            data.$searchKey = $( 'input[name="s"]', data.$search );
            data.$searchOpen = $( '[data-action="open-search"]', data.$search );
            data.$searchClose = $( '[data-action="close-search"]', data.$search );

            menu.$.data( 'MainMenu', data );

            // Search
            data.$searchKey
                .on( 'focus', function(){
                    Dropdown.closeAll();
                    MainMenu.toggleSearch( data, 'open', true, false );
                })
                .on( 'blur', function(){
                    if( data.closeBlur ){
                        MainMenu.toggleSearch( data, 'close' );
                    }
                })
                .on( 'keyup', function( e ){
                    MainMenu.$keywords.not(this).val( this.value );
                });
            ;
            data.$searchOpen
                .on( 'click', function( e ){
                    e.preventDefault();
                })
                .on( 'mouseup', function(){
                    MainMenu.toggleSearch( data, 'open' );
                })
            ;
            data.$searchClose
                .on( 'click', function( e ){
                    e.preventDefault();
                })
                .on( 'mouseup', function( e ){
                    MainMenu.toggleSearch( data, 'close' );
                })
            ;

        },
        
        // Overlay
        overlayOpen : function( data ){
            data.$overlay.addClass( 'show' );
        },
        overlayClose : function( data ){
            data.$overlay.removeClass( 'show' );
        },

        lock : function( data ){
            data.locked = true;
            MainMenu.overlayOpen( data );
            Utils.lockScroll();
        },

        unlock : function( data ){
            data.locked = false;
            MainMenu.overlayClose( data );
            Utils.unlockScroll();
        },

        // Search box
        toggleSearch : function( data, action, closeBlur, setFocus ){

            if( data.$.hasClass( 'keyword-filters' ) ){

                data.$searchKey.val( '' );
                
            }
            else {

                // Toggle
                if( action === 'open' ){
                    MainMenu.openSearch( data, closeBlur, setFocus );
                }
                else {
                    MainMenu.closeSearch( data );
                }
            
            }

        },
        openSearch : function( data, closeBlur, setFocus ){

            Dropdown.closeAll();

            data.closeBlur = closeBlur === true;
            
            data.$.addClass( 'searching' );

            if( setFocus !== false ){
                data.$searchKey.focus();
            }
        
        },
        closeSearch : function( data ){
            data.$.removeClass( 'searching' );
        }
        
    }
    $(function(){ MainMenu.init(); });

})(jQuery);
